<template>
  <Alert :type="alertMessage[0]" show-icon :style="{display:isShow?'inline-block':'none'}">{{alertMessage[1]}}</Alert>
</template>
<script>
// let _msg=this.msg;
// console.log(_msg);
export default {
  props: ['msg'],
  name: "validMsg",

  data() {
    return {
      alertMessage: this.msg,
      showIcon: false,
      isShow: false,
    }
  },
  computed: {
    // aMsg: {
    //   get: function() {
    //     return this.msg
    //   },
    //   set: function(v) {
    //    this.msg=v
    //   }
    // }
  },
  watch:{
  	msg(){
  		 this.alertMessage = this.msg
  		 this.isShow=true
  	}
  }
}

</script>
<style>
<style>
